import { apiRequest } from './apiService';

// Sales Plans
export const fetchSalesPlans = async () => {
  return await apiRequest('/sales/sales-plans', 'GET');
};

export const createSalesPlan = async (planData: any) => {
  return await apiRequest('/sales/sales-plans', 'POST', planData);
};

export const fetchPlanById = async (id: any) => {
  return await apiRequest(`/sales/sales-plans/${id}`, 'GET');
};
export const fetchPlanByNatural_key = async (id: any) => {
  return await apiRequest(`/sales/sales-plans/key/${id}`, 'GET');
};

// Create a new plan
export const createPlan = async (data: any) => {
  return await apiRequest('/sales/sales-plans', 'POST', data);
};

// Update an existing plan
export const updatePlan = async (id: string, data: any) => {
  return await apiRequest(`/sales/sales-plans/${id}`, 'PUT', data);
};
